import AddPurchasePanel from "@/components/add-purchase-panel";
import TopNavigation from "@/components/top-navigation";
import VerticalScrollView from "@/components/vertical-scrollview";
import { RewardGiftCard, RewardGiftCardGroup } from "@akc/mx-taro-h5-components";
import { Popup } from "antd-mobile";
import React from "react";
import styles from "./index.module.less";

import { useRgModal } from "./hooks/userRgModal";

const RewardGiftDetail: React.FC = () => {
  const rgModal = useRgModal();

  return (
    <>
      <VerticalScrollView className={styles.rewardGiftDetail}>
        <TopNavigation
          className={styles.topNavigation}
          hideHomeText={true}
          hideSearchIcon={true}
          hideCartIcon={true}
          hideFavoriteIcon={true}
        />
        <div className={styles.body}>
          {rgModal.freeGiftPromoActivityList.map((_, index) => (
            <RewardGiftCard
              className={styles.rewardGiftCard}
              key={_?.promoActivityId}
              freeGiftPromoActivity={_}
              handleAction={rgModal.onHandleAction}
            />
          ))}
        </div>
      </VerticalScrollView>
      <Popup
        className={styles.popupContent}
        visible={rgModal.popupVisible}
        onMaskClick={() => rgModal.setPopupVisible(false)}>
        <div className={styles.popupClose}>
          <img src={rgModal.closeIcon} alt="close" onClick={() => rgModal.setPopupVisible(false)} />
        </div>
        <div className={styles.rewardGiftGroup}>
          <div className={styles.rewardGiftGroupHeader}>
            <span className={styles.headerTitle}>赠品活动</span>
            {rgModal.actRuleDescOpen && (
              <div className={styles.headerRule} onClick={rgModal.onRule}>
                <span>规则说明</span>
                <img src={rgModal.arrowRight} alt="arrow" />
              </div>
            )}
          </div>
          <div className={styles.ruleTip}>
            <span>数量有限，送完为止，赠品不支持售后</span>
            <span className={styles.ruleTipMore}>（每单只送1次,不叠加赠送）</span>
          </div>
          <VerticalScrollView className={styles.rewardGiftGroupScrollview}>
            <RewardGiftCardGroup
              freeGiftPromoActivity={rgModal.freeGiftPromoActivity}
              handleAction={rgModal.onHandleGroupAction}
            />
          </VerticalScrollView>
        </div>

        <div className={styles.rewardGiftGroupFooter}>
          <div className={styles.footerCount}>
            已选 (<span>{rgModal.getCount("isSelected")}</span>/{rgModal.getCount("total")})
          </div>
          <div className={styles.footerBtn} onClick={rgModal.onConfirm}>
            确认更换
          </div>
        </div>
      </Popup>

      <AddPurchasePanel
        visible={rgModal.visible}
        product={rgModal.productDetail}
        close={rgModal.handleCloseModal}
        confirm={rgModal.handleConfirmModal}
        trackData={{ page_name: rgModal.page_name }}
        giftCount={rgModal.productDetail?.giftCount}
        buttonName="确认更换"
        hideWantToBuy={true}
        isModifySku={true}
        needLoading={false}
        isGiftPurchase={false}
        canDirectReturnSku={true}
        canSelectAllSkuFromModifySku={true}
      />
    </>
  );
};

export default RewardGiftDetail;
